import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-access-group-select" }

import { computed } from "vue"
import AppSelect, {
	SelectItem,
	SelectModelValue
} from "@/components/ui-kit/select/AppSelect.vue"
import { headerStore } from "@/store/header"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderAccessGroupSelect',
  setup(__props) {

const store = headerStore()

const items = computed<SelectItem[]>(() =>
	store.accessGroups.map(g => ({ id: g.Id, label: g.Name }))
)

const onChange = (value: SelectModelValue) => {
	if (Array.isArray(value)) return
	store.setActiveAccessGroup(value == null ? null : Number(value))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppSelect, {
      "model-value": _unref(store).currentAccessGroupId,
      items: items.value,
      placeholder: "Группа доступа",
      "dropdown-class": "header-select-dropdown",
      "onUpdate:modelValue": onChange
    }, null, 8, ["model-value", "items"])
  ]))
}
}

})